module.exports = __webpack_public_path__ + "static/media/deadly-3.a08f5194.png";